function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useListItem } from '@floating-ui/react';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../../internal';
import { SearchBar as _SearchBar } from '../../SearchBar';
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchBar = props => {
  var styles = useMultiStyleConfig('SelectNew', {});
  var {
    ref
  } = useListItem();
  return /*#__PURE__*/_jsx(Box, {
    "data-component": "SelectNew.SearchBar",
    __css: styles['searchBar'],
    children: /*#__PURE__*/_jsx(_SearchBar, _objectSpread(_objectSpread({}, props), {}, {
      isFullWidth: true,
      ref: ref
    }))
  });
};
SearchBar.displayName = 'SelectNew.SearchBar';
//# sourceMappingURL=SearchBar.js.map